export default {
  forgotPassword: 'FORGOT_PASSWORD',
  forgotPasswordSuccess: 'FORGOT_PASSWORD_SUCCESS',
  forgotPasswordFailed: 'FORGOT_PASSWORD_FAILED',
  toggleModal: 'TOGGLE_FORGOT_PASSWORD_MODAL',
};
